import { gql } from '@apollo/client';
import { LocaleCode, LOCALE_BY_CODE } from '../../../../../utils/Locale';
import { queryWithFallbackKey } from '../../../common/tools/queryWithFallbackKey';

export const GET_RESOURCE_TYPES_QUERY = queryWithFallbackKey(
    gql`
        query getResourceTypeListing($defaultLanguage: String!) {
            getObjectFolder(
                fullpath: "/Resource Library/Categorization/Resource Types"
                defaultLanguage: $defaultLanguage
            ) {
                children {
                    ... on object_ResourceTypeGroup {
                        id
                        key
                        name
                        resourceTypes {
                            id
                            key
                            name
                        }
                    }
                }
            }
        }
    `,
    'GET_RESOURCE_TYPES_QUERY'
);

export function getResourceTypesQueryVariables(localeCode: LocaleCode) {
    return {
        defaultLanguage: LOCALE_BY_CODE[localeCode].pimcoreCode,
    };
}
